import { render, staticRenderFns } from "./EmployeeStatusInput.vue?vue&type=template&id=5a572f69&"
import script from "./EmployeeStatusInput.vue?vue&type=script&lang=js&"
export * from "./EmployeeStatusInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports